// CONFIGURATION SETTING - VEE-VALIDATE

export const VeeValidateDictionary = {
  // custom: {
  //  email: {
  //    exist: 'Your email is empty'
  //  } //,
  //  name: {
  //    required: () => 'Your name is empty'
  //  }
  // },
  en: {
    attributes: {
      email: 'Email',
      subject: 'Reason',
      firstName: 'First Name',
      lastName: 'Last Name',
      checkboxAgreeTerms: 'Agreement on our Terms'
    },
    messages: {
      email: (field) => `Ouch! Looks like the ${field} is invalid.`,
      required: (field) => `Ouch! We need your ${field} to rock and roll.`,
      max: (field, [length]) => `No way! The ${field} should be short and sweet. Max ${length} characters.`,
      exist: (field) => `Ouch! The ${field} is already in use.`
    }
  }
}

export const VeeValidateConfig = {
  classes: true,
  events: 'blur'
}



// WEBPACK FOOTER //
// ./src/helpers/VeeValidateConfig.js